// src/packages/msig/pa/msig_pa_triple_care_2025/MSIGTripleCareDetails.jsx
import React from "react";
import "./msig_triple_care.css";

/**
 * MSIG — E-PA Triple Care (Plan 1–9)
 * Zero-index safe (ไม่มี {index} ใน JSX)
 * สรุปผลประโยชน์และเบี้ย (จัดรูปเพื่อขายจากเอกสารที่อัปโหลด)
 */

const fmt = (x) => x?.toLocaleString?.() ?? x;

const PLANS = ["แผน1","แผน2","แผน3","แผน4","แผน5","แผน6","แผน7","แผน8","แผน9"];

const benefits = [
  { key: "life_acc",       name: "เสียชีวิต/สูญเสียอวัยวะ/สายตา/ทุพพลภาพถาวร (อุบัติเหตุทั่วไป)", vals: [100000,200000,300000,400000,500000,750000,1000000,1500000,2000000] },
  { key: "life_murder",    name: "ฆาตกรรม/ทำร้ายร่างกาย",                              vals: [100000,200000,300000,400000,500000,750000,1000000,1500000,2000000] },
  { key: "life_public",    name: "อุบัติเหตุสาธารณะ",                                   vals: [200000,400000,600000,800000,1000000,1500000,2000000,3000000,4000000] },
  { key: "life_motorcycle",name: "ขับขี่/โดยสารรถจักรยานยนต์",                          vals: [50000,100000,150000,200000,250000,375000,500000,500000,500000] },
  { key: "med",            name: "ค่ารักษาพยาบาล/ครั้ง (รวมกรณีมอเตอร์ไซค์)",           vals: [10000,20000,30000,40000,50000,75000,100000,150000,200000] },
  { key: "dental",         name: "ค่าทันตกรรมจากอุบัติเหตุ",                             vals: [5000,10000,10000,20000,20000,20000,30000,50000,50000] },
  { key: "broken",         name: "กระดูกแตก/ร้าว/ทิ่มทะลุ (ตามตารางผลประโยชน์)",         vals: [5000,10000,10000,20000,20000,20000,30000,50000,50000] },
  { key: "dhi",            name: "ชดเชยรายได้ระหว่างนอน รพ. (สูงสุด 30 วัน) / วันละ",    vals: ["-","-","-","-",500,500,500,500,500] },
];

// เบี้ยรายปี (รวมภาษีอากร) — ตัวอย่างตามชั้นอาชีพที่เปิดรับ
const premiumClass12 = [899,1399,1899,2299,2599,3949,5199,6599,8199];
const premiumClass3  = [1299,2099,2699,3799,4599,null,null,null,null]; // null = ไม่เปิดขาย

export default function MSIGTripleCareDetails({ onQuote }) {
  return (
    <div className="pkg-detail msig-pa-triple">
      <h2>MSIG PA Triple Care — แผน 1–9</h2>
      <p className="pkg-note">
        สรุปผลประโยชน์และเบี้ยประกันจากเอกสารบริษัท (อายุรับ 1–60 ปี ต่ออายุได้ถึง 70 ปี; อาชีพชั้น 1–3)
      </p>

      {/* ผลประโยชน์ต่อแผน */}
      <div className="pkg-table-wrap">
        <h3 className="pkg-section">ผลประโยชน์ต่อแผน</h3>
        <table className="pkg-table">
          <thead>
            <tr>
              <th>ความคุ้มครอง</th>
              {PLANS.map((p) => <th key={`plan-h-${p}`}>{p}</th>)}
            </tr>
          </thead>
          <tbody>
            {benefits.map((b) => (
              <tr key={`bf-${b.key}`}>
                <td className="pkg-left">{b.name}</td>
                {b.vals.map((v, i) => (
                  <td key={`bf-${b.key}-${i}`}>{typeof v === "number" ? fmt(v) : v}</td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* เบี้ยตามชั้นอาชีพ */}
      <div className="pkg-table-wrap">
        <h3 className="pkg-section">เบี้ยประกันรายปี (รวมภาษี) ตามชั้นอาชีพ</h3>
        <table className="pkg-table">
          <thead>
            <tr>
              <th>ชั้นอาชีพ</th>
              {PLANS.map((p) => <th key={`ph-${p}`}>{p}</th>)}
            </tr>
          </thead>
          <tbody>
            <tr>
              <td className="pkg-left">ชั้น 1–2</td>
              {premiumClass12.map((v, i) => <td key={`c12-${i}`}>{fmt(v)}</td>)}
            </tr>
            <tr>
              <td className="pkg-left">ชั้น 3</td>
              {premiumClass3.map((v, i) => <td key={`c3-${i}`}>{v ? fmt(v) : "N/A"}</td>)}
            </tr>
          </tbody>
        </table>
      </div>

      <h3 className="pkg-section">เงื่อนไขสำคัญ (ย่อ)</h3>
      <ul className="pkg-bullets">
        <li>อายุรับ: 1–60 ปี (ต่ออายุได้ถึง 70 ปี)</li>
        <li>ผู้อยู่อาศัยในประเทศไทย; สัญชาติไทย/ต่างชาติที่มีใบอนุญาตทำงาน</li>
        <li>ชั้นอาชีพ 1–3 (แผนสูงบางแผนไม่เปิดขายชั้น 3)</li>
      </ul>

      <div className="pkg-foot">
        <p className="pkg-note">* โปรดอ่านกรมธรรม์/ตารางผลประโยชน์ฉบับเต็มก่อนตัดสินใจ</p>
        <button className="pkg-quote-btn" onClick={onQuote} aria-label="ขอใบเสนอราคา MSIG PA Triple Care">
          ขอใบเสนอราคา
        </button>
      </div>
    </div>
  );
}
